import { render, staticRenderFns } from "./proCardofDistribution.vue?vue&type=template&id=89ab38f8&"
import script from "./proCardofDistribution.vue?vue&type=script&lang=js&"
export * from "./proCardofDistribution.vue?vue&type=script&lang=js&"
import style0 from "./proCardofDistribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89ab38f8')) {
      api.createRecord('89ab38f8', component.options)
    } else {
      api.reload('89ab38f8', component.options)
    }
    module.hot.accept("./proCardofDistribution.vue?vue&type=template&id=89ab38f8&", function () {
      api.rerender('89ab38f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/proCardofDistribution.vue"
export default component.exports